import { AutoMap } from "@automapper/classes"
import { BaseDOM } from "../base.dom"
import { Prelevement } from "../prelevement"
import { EClasse } from "./enums/classe"
import { ELocalisationQualifSalle } from "./enums/localisation-salle"
import { ESystemeTraitementAir } from "./enums/systeme-traitement-air"
import { ETestFumee } from "./enums/test-fumee"
import { Reprise } from "./reprise"
import { Soufflage } from "./soufflage"
import { ZoneCompare } from "./zone-compare"
import { EClasseBPP } from "./enums/classe-bpp"
import { EClasseBPPH } from "./enums/classe-bpph"
import { EAirQFType } from "./enums/air-qf-type"
import { EClasseComptageParticulaire } from "./enums/classe-comptage-particulaire"

export class PrelevementQualifSalle extends BaseDOM<PrelevementQualifSalle> {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Observations: string = ''
    @AutoMap()
    PersonnesPresentes?: number
    @AutoMap()
    SystemeTraitementAir: ESystemeTraitementAir = ESystemeTraitementAir.FluxNonUnidirectionnel
    @AutoMap()
    Prelevement: Prelevement = new Prelevement()

    @AutoMap(() => [Soufflage])
    SoufflageList: Soufflage[] = []
    @AutoMap(() => [Reprise])
    RepriseList: Reprise[] = []
    @AutoMap(() => [ZoneCompare])
    ZoneAComparerList: ZoneCompare[] = []
    @AutoMap(() => [ZoneCompare])
    ZoneAComparerSasList: ZoneCompare[] = []
    @AutoMap()
    LocalisationDeSalle: ELocalisationQualifSalle = ELocalisationQualifSalle.BlocOperatoire
    @AutoMap()
    AutreLocalisationDeSalle: string = ''
    @AutoMap()
    Classe?: EClasse | EClasseBPP | EClasseBPPH | EClasseComptageParticulaire
    // @AutoMap()
    // HeureDebut?: Temporal.PlainDateTime;
    @AutoMap()
    SurfaceZAC?: number
    @AutoMap()
    Volume?: number
    /** BASE 64 IMAGE */
    @AutoMap()
    Schema: string = ''
    @AutoMap()
    Temperature?: number
    @AutoMap()
    Humidite?: number
    @AutoMap()
    Luminosite?: number
    @AutoMap()
    PressionAcoustique?: number
    @AutoMap()
    TestFumee: ETestFumee = ETestFumee.AbsenceConfinementSalle

    @AutoMap()
    PourcentageAirNeuf?: number
    @AutoMap()
    Plan: string = ''
    @AutoMap()
    Type: EAirQFType = EAirQFType.Standard
    @AutoMap()
    ProduitDangereux: boolean = false
}